import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function Problem() {
  return <section className="py-24 bg-forest text-offwhite px-6 lg:px-8" data-id="element-155">
      <div className="max-w-4xl mx-auto" data-id="element-156">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex items-center gap-4 mb-8" data-id="element-157">
          <AlertTriangle className="text-amber" size={32} data-id="element-158" />
          <h2 className="text-4xl md:text-5xl font-bold text-offwhite" data-id="element-159">
            The Hidden Crisis
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-8 text-lg md:text-xl text-offwhite/90 leading-relaxed" data-id="element-160">
          <p data-id="element-161">
            We live in the age of overfeeding and cellular malnutrition. You can
            eat three times a day and still be biologically "starving."
          </p>
          <p data-id="element-162">
            Chronic stress drains your magnesium reserves, blue light from
            screens depletes your B vitamins, and sweat or constant coffee flush
            out the electrolytes that keep your neurons firing.
          </p>
          <div className="p-6 md:p-8 bg-white/5 border-l-4 border-amber rounded-r-xl" data-id="element-163">
            <p className="font-serif italic text-xl md:text-2xl" data-id="element-164">
              When these nutritional gaps appear, your body goes into
              "power-saving mode." Your focus disappears, your patience runs
              out, and your energy crashes exactly when you need it most.
            </p>
          </div>
          <p data-id="element-165">
            Trying to fix this with more caffeine is like whipping a tired
            horse: it only speeds up the final collapse.
          </p>
        </motion.div>
      </div>
    </section>;
}